'use strict';
 /**
 * @author Maxim Seredkin
 */
export default ['$resource',
    function ($resource) {
        return $resource('api/support-tools/:supportToolId', null, {
            getAll: {method: 'GET'},
            get: {method: 'GET'},
            create: {method: 'POST'},
            update: {method: 'PUT'},
            remove: {method: 'DELETE'},
            enable: {url: 'api/support-tools/:supportToolId/enable', method: 'PUT'},
            delete: {url: 'api/support-tools/:supportToolId/delete', method: 'PUT'},
            getDefault: {url: 'api/support-tools/default', method: 'GET'},
            setDefault: {url: 'api/support-tools/:supportToolId/default', method: 'PUT'},
            isUniqueName: {url: 'api/support-tools/unique/name/:name', method: 'GET'}
        });
    }];